import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-language',
  imports: [CommonModule],
  templateUrl: './language.component.html',
  styleUrl: './language.component.css'
})
export class LanguageComponent {
  language = localStorage.getItem('language') || "English"

  onClick = () => {
    this.language = this.language === "English" ? "French" : "English";
    localStorage.setItem('language', this.language);
  }


  isChecked = this.language !== "English" ? true : false;

  get toggleText(): string {
    return this.isChecked ?  'FR' :'EN' ;
  }

  onToggleChange(event: Event) {
    this.onClick()
    const input = event.target as HTMLInputElement;
    this.isChecked = input.checked;
  }
}
